
const cache = {};

/**
 * Save a value in the cache with the given key.
 * @param {string} key 
 * @param {any} value 
 * @param {number|null} ttl Time to live in milliseconds
 */
export function setCache(key, value, ttl = null) {
  cache[key] = value;
  if (ttl !== null) {
    setTimeout(() => {
      delete cache[key];
    }, ttl);
  }
  console.log('cache updated', cache);
}

/**
 * Get a value from the cache by its key.
 * @param {string} key 
 * @returns {any}
 */
export function getCache(key) {
  return cache[key];
}

/**
 * Clear a value from the cache by its key.
 * @param {string} key 
 */
export function clearCache(key) {
  delete cache[key];
}

/**
 * Clear the entire cache.
 */
export function flushCache() {
  cache = {};
}
